module.exports = __webpack_public_path__ + "i18n/fr.eace094d5307c3d4ad68fe880eb50d0e.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1855
// module chunks = 0